import { z } from 'zod';

export const uploadableScheme = z.object({
  url: z.string(),
  size: z.number(),
  name: z.string(),
  type: z.string(),
  compress: z.boolean().default(false),
});

export type UppyFileMeta = {
  FileName: string;
  FileType: string;
  UID: number;
  ChatSessionID?: number;
};

export type Uploadable = z.infer<typeof uploadableScheme>;
